/**
 * 交易所数据采集配置常量
 * 提供下拉选项等配置项
 *
 * @author page
 * @date 2026-04-24
 */
import type {
    ConfigTypeOption,
    DataSourceOption,
    ExchangeOption,
    ProductTypeOption,
    TimeframeOption,
} from '../types/exchangeDataConfig';

/** 交易所选项列表 */
export const EXCHANGE_OPTIONS: ExchangeOption[] = [
    {value: 'OKX', label: 'OKX'},
    {value: 'Bybit', label: 'Bybit'},
    {value: 'Hyperliquid', label: 'Hyperliquid'},
];

/** 产品类型选项列表 */
export const PRODUCT_TYPE_OPTIONS: ProductTypeOption[] = [
    {value: 'contract', label: '合约'},
    {value: 'spot', label: '现货'},
];

/** 配置类型选项列表 */
export const CONFIG_TYPE_OPTIONS: ConfigTypeOption[] = [
    {value: 'setting', label: '用户配置'},
    {value: 'temporary', label: '系统归集'},
];

/** 数据源选项列表 */
export const DATA_SOURCE_OPTIONS: DataSourceOption[] = [
    {value: 'live', label: '实盘'},
    {value: 'paper', label: '模拟'},
];

/** 时间帧选项列表 */
export const TIMEFRAME_OPTIONS: TimeframeOption[] = [
    {value: '1m', label: '1分钟'},
    {value: '5m', label: '5分钟'},
    {value: '15m', label: '15分钟'},
    {value: '1h', label: '1小时'},
    {value: '4h', label: '4小时'},
    {value: '1d', label: '1天'},
];
